import axios from 'axios';

axios.defaults.withCredentials = true;

export default axios.create({
  baseURL: '/api',
  timeout: 30000,
  withCredentials: true,
});
